export default {
    default: {
        name: '名称',
        fullname: '全称',
        key: '标识',
        createdAt: '创建于',
        updatedAt: '更新于',
        edit: '编辑',
        create: '创建',
        delete: '删除',
        detail: '详情',
        product: '产品',
        device: '设备',
        desc: '描述',
        category: '品类',
        id: 'ID',
        custom: '自定义',
        info: '信息',
        fun: '功能',
        def: '定义',
        secret: '密钥',
        success: '成功',
        fail: '失败',
        error: '异常',
        confirm: '确认',
        cancel: '取消',
        add: '添加',
        property: '属性',
        prop: '属性',
        event: '事件',
        service: '服务',
        type: '类型',
        identifier: '标识符',
        data: '数据',
        max: '最大',
        min: '最小',
        step: '步长',
        unit: '单位',
        text: '文本',
        length: '长度',
        value: '值',
        range: '范围',
        read: '读',
        write: '写',
        only: '只',
        readOnly: '只读',
        bind: '绑定',
        unbind: '解绑',
        input: '输入',
        output: '输出',
        param: '参数',
        remark: '备注',
        belongsTo: '所属',
        active: '激活',
        online: '在线',
        true: '是',
        false: '否',
        save: '保存',
        thingModel: '物模型',
        enum: '枚举',
        bool: '布尔',
        item: '项',
        like: '如',
        close: '关',
        open: '开',
        status: '状态',
        image: '图片',
        mac: 'Mac',
        mqtt: 'Mqtt',
        username: '用户名',
        password: '密码',
        topic: '主题',
        call: '调用',
        callback: '回调',
        report: '上报',
        app: 'App',
        task: '任务',
        runAt: '执行于',
        startedAt: '起始于',
        user: '用户',
        share: '分享',
        unshare: '取消分享',
        bindAndActive: '绑定并激活',
        instr: '指令',
        tmpl: '模板',
        code: '码',
        hardware: '硬件',
        software: '软件',
        version: '版本',
        register: '注册',
        way: '方式',
        phoneNumber: '手机号',
        email: '邮箱',
        login: '登录',
        loginName: '登录名',
        avatar: '头像',
        nature: '自然',
        batch: '批量',
        generate: '生成',
        gen: '生成',
        number: '数量',
        no: '不',
        run: '执行',
        spend: '花费',
        time: '时间',
        reason: '原因',
        stack: '堆栈',
        random: '随机',
        import: '导入',
        control: '控制',
        debug: '调试',
        send: '发送',
        client: '客户端',
        firmware: '固件',
        list: '列表',
        enabled: '启用',
        disabled: '停用',
        publish: '发布',
        unusual: '异常',
        upgrading: '升级中',
        support: '支持',
        fuzzy: '模糊',
        activeCode: '激活码',
        isValid: '是否有效',
        isUsable: '是否可用',
        server: '服务器',
        retain: '保留',
        msg: '消息',
        message: '消息',
        host: '主机',
        port: '端口',
        all: '所有',
        upgrade: '升级',
        content: '内容',
        level: '等级',
        force: '强制',
        visitor: '访客',
        view: '视图',
        search: '搜索',
        mode: '模式',
        current: '当前',
        latest: '最新',
        config: '配置',
        directory: '目录',
        dir: '目录',
        upload: '上传',
        alias: '别名',
        serverend: '服务端',
        deviceend: '设备端',
        payload: '载荷',
        generator: '生成器',
        expression: '表达式',
        times: '次数',
        company: '企业',
        statistics: '统计',
        total: '总数',
        used: '已使用',
        unused: '未使用',
        book: '图书',
        title: '标题',
        summary: '简介',
        author: '作者',
        publisher: '出版社',
        renter: '租借人',
        location: '位置',
        exportRentalLog: '导出借阅日志',
        date: '日期',
        start: '起始',
        end: '结束',
        rental: '租借',
        duration: '时长',
        dingtalk: '钉钉',
        result: '结果',
    },
    dialog: {
        close: '关闭',
    },
    sentence: {
    },
    eventType: {
        info: '信息',
        warn: '告警',
        error: '故障',
    },
    route: {
        dashboard: '首页',
        documentation: '文档',
        guide: '引导页',
        permission: '权限测试页',
        rolePermission: '角色权限',
        pagePermission: '页面权限',
        directivePermission: '指令权限',
        icons: '图标',
        components: '组件',
        tinymce: '富文本编辑器',
        markdown: 'Markdown',
        jsonEditor: 'JSON 编辑器',
        splitPane: 'Splitpane',
        avatarUpload: '头像上传',
        dropzone: 'Dropzone',
        sticky: 'Sticky',
        countTo: 'Count To',
        componentMixin: '小组件',
        backToTop: '返回顶部',
        draggableDialog: '可拖拽对话框',
        draggableKanban: '可拖拽看板',
        draggableList: '可拖拽列表',
        draggableSelect: '可拖拽选择',
        charts: '图表',
        barChart: '柱状图表',
        lineChart: '折线图',
        mixedChart: '混合图表',
        example: '综合实例',
        nested: '路由嵌套',
        menu1: '菜单 1',
        'menu1-1': '菜单 1-1',
        'menu1-2': '菜单 1-2',
        'menu1-2-1': '菜单 1-2-1',
        'menu1-2-2': '菜单 1-2-2',
        'menu1-3': '菜单 1-3',
        menu2: '菜单 2',
        table: '表格',
        dynamicTable: '动态表格',
        draggableTable: '可拖拽表格',
        inlineEditTable: '表格内编辑',
        complexTable: '综合表格',
        tab: '分栏',
        form: '表单',
        createArticle: '创建文章',
        editArticle: '编辑文章',
        articleList: '文章列表',
        errorPages: '错误页面',
        page401: '401',
        page404: '404',
        errorLog: '错误日志',
        excel: 'Excel',
        exportExcel: '导出 Excel',
        selectExcel: '导出 已选择项',
        mergeHeader: '导出 多级表头',
        uploadExcel: '上传 Excel',
        zip: 'Zip',
        pdf: 'PDF',
        exportZip: '导出 Zip',
        theme: '换肤',
        clipboard: '粘贴板',
        i18n: '国际化',
        externalLink: '外链',
        profile: '个人中心',
        tree: '树形控件',
        test: '测试',
        queryBuilder: '查询构造器',
        userMange: '用户管理',
        taskMange: '任务管理',
        userDetail: '用户详情',
        accordion: '手风琴',
        company: '企业',
        companyMange: '企业管理',
        companyDetail: '企业详情',
        companyRegister: '注册企业',
        bookMange: '图书管理',
        bookDetail: '图书详情',
    },
    navbar: {
        logout: '退出登录',
        dashboard: '首页',
        github: '项目地址',
        theme: '换肤',
        size: '布局大小',
        profile: '个人中心'
    },
    login: {
        title: '图书管理后台',
        login: '登录',
        account: '账号',
        password: '密码',
        any: '随便填',
        thirdparty: '第三方登录',
        thirdpartyTips: '本地不能模拟，请结合自己业务进行模拟！！！',
        copyright: '未来科技 版权所有'
    },
    documentation: {
        documentation: '文档',
        github: 'Github 地址'
    },
    permission: {
        createRole: '新增角色',
        editPermission: '编辑权限',
        roles: '你的权限',
        switchRoles: '切换权限',
        tips: '在某些情况下，不适合使用 v-permission。例如：Element-UI 的 el-tab 或 el-table-column 以及其它动态渲染 dom 的场景。你只能通过手动设置 v-if 来实现。',
        delete: '删除',
        confirm: '确定',
        cancel: '取消'
    },
    guide: {
        description: '引导页对于一些第一次进入项目的人很有用，你可以简单介绍下项目的功能。本 Demo 是基于',
        button: '打开引导'
    },
    components: {
        documentation: '文档',
        tinymceTips: '富文本是管理后台一个核心的功能，但同时又是一个有很多坑的地方。在选择富文本的过程中我也走了不少的弯路，市面上常见的富文本都基本用过了，最终权衡了一下选择了Tinymce。更详细的富文本比较和介绍见',
        stickyTips: '当页面滚动到预设的位置会吸附在顶部',
        backToTopTips1: '页面滚动到指定位置会在右下角出现返回顶部按钮',
        backToTopTips2: '可自定义按钮的样式、show/hide、出现的高度、返回的位置 如需文字提示，可在外部使用Element的el-tooltip元素',
        imageUploadTips: '由于我在使用时它只有vue@1版本，而且和mockjs不兼容，所以自己改造了一下，如果大家要使用的话，优先还是使用官方版本。'
    },
    table: {
        dynamicTips1: '固定表头, 按照表头顺序排序',
        dynamicTips2: '不固定表头, 按照点击顺序排序',
        dragTips1: '默认顺序',
        dragTips2: '拖拽后顺序',
        title: '标题',
        importance: '重要性',
        type: '类型',
        remark: '点评',
        search: '搜索',
        add: '添加',
        export: '导出',
        reviewer: '审核人',
        id: '序号',
        date: '时间',
        author: '作者',
        readings: '阅读数',
        status: '状态',
        actions: '操作',
        edit: '编辑',
        publish: '发布',
        draft: '草稿',
        delete: '删除',
        cancel: '取消',
        confirm: '确定'
    },
    example: {
        warning: '创建和编辑页面是不能被 keep-alive 缓存的，因为keep-alive 的 include 目前不支持根据路由来缓存，所以目前都是基于 component name 来进行缓存的。如果你想类似的实现缓存效果，可以使用 localStorage 等浏览器缓存方案。或者不要使用 keep-alive 的 include，直接缓存所有页面。详情见'
    },
    errorLog: {
        tips: '请点击右上角bug小图标',
        description: '现在的管理后台基本都是spa的形式了，它增强了用户体验，但同时也会增加页面出问题的可能性，可能一个小小的疏忽就导致整个页面的死锁。好在 Vue 官网提供了一个方法来捕获处理异常，你可以在其中进行错误处理或者异常上报。',
        documentation: '文档介绍'
    },
    excel: {
        export: '导出',
        selectedExport: '导出已选择项',
        placeholder: '请输入文件名(默认excel-list)'
    },
    zip: {
        export: '导出',
        placeholder: '请输入文件名(默认file)'
    },
    pdf: {
        tips: '这里使用 window.print() 来实现下载pdf的功能'
    },
    theme: {
        change: '换肤',
        documentation: '换肤文档',
        tips: 'Tips: 它区别于 navbar 上的 theme-pick, 是两种不同的换肤方法，各自有不同的应用场景，具体请参考文档。'
    },
    tagsView: {
        refresh: '刷新',
        close: '关闭',
        closeOthers: '关闭其它',
        closeAll: '关闭所有'
    },
    settings: {
        title: '系统布局配置',
        theme: '主题色',
        showTagsView: '显示 Tags-View',
        showSidebarLogo: '显示侧边栏 Logo',
        fixedHeader: '固定 Header',
        sidebarTextTheme: '侧边栏文字主题色'
    },
    m: {
        device: {
            channelNumber: '可控路数',
            funNumber: '支持功能组合数',
            battery: '电量',
            network: '网络信号强度',
        },
    }
}
